import { RoleInterface } from "../RoleInterface";
import { Role } from "../Role";
import Translator from "../../../../../Translation/Translator";

class User extends Role implements RoleInterface  {

  public static contactRoleId: number = 1;

  public getName(): string {
    return Translator.trans("role-manager");
  }

}

export { User }
